import { green, deepPurple } from '@mui/material/colors';

export const themeGreen = {
	palette: {
		primary: {
			main: green[700],
		}, 
		secondary: deepPurple,
	},
};

export const ThemeActions = {
    Theme: 'Theme',
};